module.exports = {

   // Language configuration in your Prismic repository: Settings / Translations & locals
   defaultLanguage: 'it-it',
   langs: ['en-gb', 'de-de'],
}
